<template>
  <page>
    <div slot="headerLeft">
      <el-select clearable v-model="params.spId" :placeholder="$t('deviceList.customer')">
        <el-option
          v-for="item in serviceList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <el-select clearable v-model="params.packageName" :placeholder="$t('appList.appName')">
        <el-option
          v-for="item in appList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>

      <div class="timeFrame">
        <el-radio-group v-model="timeFrame" @change="timeChange">
          <el-radio label="today">{{ $t('adminHomePage.today') }}</el-radio>
          <el-radio label="yesterday">{{ $t('statisticalManagement.yesterday') }}</el-radio>
          <el-radio label="recentSevenDays">{{ $t('statisticalManagement.last7days') }}</el-radio>
          <el-radio label="recentThirtyDays">{{ $t('statisticalManagement.lastMonth') }}</el-radio>
          <el-radio label="custom">{{ $t('statisticalManagement.customTimeRange') }}</el-radio>
        </el-radio-group>

        <div v-if="timeFrame === 'custom'" class="picker-wrap">
          <el-date-picker
            class="zhiTime"
            type="date"
            v-model="params.startTime"
            value-format="yyyy-MM-dd"
            :placeholder="$t('startDate')"
            :picker-options="pickerOptionsStart"
            @change="timeOptions"
          />
          <span class="line">—</span>
          <el-date-picker
            class="zhiTime"
            type="date"
            v-model="params.endTime"
            :picker-options="pickerOptionsEnd"
            :placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            @focus="timeOptionsEnd"
            ref="endTime"
          />
        </div>
      </div>

      <el-button type="primary" plain @click="getData">{{ $t('query') }}</el-button>
    </div>

    <!-- <div class="common-tab">
      <span
        @click="currentType = item.type"
        :class="{ active: currentType === item.type }"
        v-for="item in spanItems"
        :key="item.type"
        class="spanItem"
        >{{ item.name }}</span
      >
    </div> -->

    <component
      ref="chart"
      :xDataType="xDataType"
      :spId="params.spId"
      :packageName="params.packageName"
      :customTime="customTime"
      :is="currentType"
    />
  </page>
</template>

<script>
import ByApp from './component/ByApp.vue'

export default {
  data() {
    return {
      xDataType: 'today',
      currentType: 'ByApp',
      params: {
        spId: '',
        packageName: '',
        startTime: '',
        endTime: ''
      },
      spanItems: [
        {
          type: 'ByApp',
          name: this.$t('statisticalManagement.appInstall')
        }
      ],
      serviceList: [],
      groupList: [],
      appList: [],
      timeFrame: 'today',
      customTime: [],

      pickerOptionsStart: {
        disabledDate(time) {
          var d = new Date()

          return time.getTime() > d.getTime()
        }
      },
      pickerOptionsEnd: {}
    }
  },
  created() {
    this.getSelectData()
  },
  components: {
    ByApp
  },
  methods: {
    async getSelectData() {
      let res = await this.$api.systemManagement.spList({ pageSize: -1 })

      this.serviceList = ((res.result && res.result.list) || []).map(item => {
        return {
          label: item.name,
          value: item.spId
        }
      })
    },

    async getAppList(spId) {
      let res = await this.$api.statisticalManagement.listBySpId({ spId })

      this.appList = res.result.map(item => {
        return {
          label: item.appName,
          value: item.packageName
        }
      })
    },

    async getData() {
      let time = {}

      if (this.xDataType !== 'custom') {
        time = this.$utils.getStartEndTime(this.xDataType)
      } else {
        if (!this.params.startTime || !this.params.endTime) {
          this.$message.warning(this.$t('statisticalManagement.selectCustomTimeRange'))
          return
        }
      }

      const sendData = JSON.parse(JSON.stringify(this.params))

      sendData.startTime = this.params.startTime || time.startTime
      sendData.endTime = this.params.endTime || time.endTime

      this.$refs.chart.getData(sendData)
    },

    timeOptions() {
      this.params.endTime = ''
    },
    timeOptionsEnd() {
      if (this.params.startTime == '' || this.params.startTime == null) {
        this.$refs.endTime.pickerVisible = false
        return this.$message.warning(this.$t('statisticalManagement.entryStartTime'))
      } else {
        this.$refs.endTime.pickerVisible = true
      }
      let that = this
      this.pickerOptionsEnd = {
        disabledDate(time) {
          let dataLast = new Date(that.params.startTime).getTime()
          return (
            //时间戳减去8.64e7 其实和24*60*60*1000一样
            time.getTime() > dataLast + 31 * 24 * 60 * 60 * 1000 ||
            time.getTime() < dataLast - 8.64e7 ||
            time.getTime() > Date.now()
          )
        }
      }
    },

    timeChange(val) {
      if (val !== 'custom') {
        this.xDataType = val
        this.params.startTime = ''
        this.params.endTime = ''
        this.customTime = []
      }
    }
  },
  watch: {
    'params.spId'(val) {
      if (val) {
        this.getAppList(val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.timeFrame,
.picker-wrap {
  display: flex;
  align-items: center;
}
</style>
